import { Map, List } from "immutable";
import { STATE_STATUS } from "constants/state-status";
import { ACCOUNT_FACILITY_ACTIONS } from "constants";
import { FacilityAccountRecord, SupplyChainListRecord } from "records/index";
const INITIAL_STATE = new Map({
    status: null,
    data: null,
    supply_chains: new Map({})
});

export default (state = INITIAL_STATE, { type, payload }) => {
    switch(type) {
    case ACCOUNT_FACILITY_ACTIONS.CREATE_FACILITY_ACCOUNT:
        return state.set("status", STATE_STATUS.CREATING);
    case ACCOUNT_FACILITY_ACTIONS.CREATED_FACILITY_ACCOUNT:
        return state
            .set("status", STATE_STATUS.CREATED)
            .set("data", new FacilityAccountRecord(payload.accountData));
    case ACCOUNT_FACILITY_ACTIONS.FAILED_CREATE_FACILITY_ACCOUNT:
        return state
            .set("status", STATE_STATUS.CREATE_FAILED);
    case ACCOUNT_FACILITY_ACTIONS.FETCH_FACILITY_ACCOUNT:
        return state.set("status", STATE_STATUS.FETCHING);
    case ACCOUNT_FACILITY_ACTIONS.FETCHED_FACILITY_ACCOUNT:
        return state
            .set("status", STATE_STATUS.FETCHED)
            .set("data", new FacilityAccountRecord(payload.accountData));
    case ACCOUNT_FACILITY_ACTIONS.FAILED_FETCH_FACILITY_ACCOUNT:
        return state
            .set("status", STATE_STATUS.FETCH_FAILED);
    case ACCOUNT_FACILITY_ACTIONS.FETCH_SUPPLY_CHAINS_LIST:
        return state.setIn(["supply_chains", payload.caseId, "status"], STATE_STATUS.FETCHING);
    case ACCOUNT_FACILITY_ACTIONS.FETCHED_SUPPLY_CHAINS_LIST:
        return state
            .setIn(["supply_chains", payload.caseId, "status"], STATE_STATUS.FETCHED)
            .setIn(
                ["supply_chains", payload.caseId, "data"],
                payload.supplychainData && 
                new List(payload.supplychainData.map(_ => 
                    new SupplyChainListRecord(_)
                )));
    case ACCOUNT_FACILITY_ACTIONS.FAILED_FETCH_SUPPLY_CHAINS_LIST:
        return state
            .setIn(["supply_chains", "status"], STATE_STATUS.FETCH_FAILED);
    case "LOGOUT":
        return INITIAL_STATE;
    default:
        return state;
    }
}; 